// Plain-language labels for the AI pre-review saved on a submission (submission.aiReview).
export const FLAG_LABELS = {
    not_relevant: "Not related to the challenge",
    internet_or_stock: "Looks like an internet / stock photo",
    ai_generated: "Looks AI-generated",
    screenshot: "Screenshot",
    no_face: "Selfie required but no face",
    duplicate_suspected: "Possible duplicate",
    gibberish_text: "Meaningless text",
};

export const VERDICT_LABELS = { approve: "Approve", reject: "Reject", unsure: "Unsure" };

export const verdictColor = (verdict) => (verdict === "approve" ? "green" : verdict === "reject" ? "red" : "inactive");

// What the AI did, in one line.
export function aiStatusText(ai) {
    if (!ai || !ai.status) return null;
    if (ai.status === "processing") return "AI review in progress";
    if (ai.status === "error") return "AI review failed";
    if (ai.actionStatus === "done" && ai.action === "approve") return "Auto-approved by AI";
    if (ai.actionStatus === "done" && ai.action === "reject") return "Auto-rejected by AI";
    if (ai.actionStatus === "failed") return `AI tried to auto-${ai.action}, needs manual review`;
    return `AI suggests: ${VERDICT_LABELS[ai.verdict] || ai.verdict} (${ai.confidence}%)`;
}
